

import { FunctionComponent } from "react";
import NeattHeaderpic from '../../../../assets/neatt-header.png';
import Button from "../../../generic/Button";
import { types } from "../../../../utils";
import { Link } from "react-router-dom";


const NeattHeader: FunctionComponent = () => {
    return (
        <header className="w-full flex flex-col-reverse lg:h-[288px] lg:p-10 mb-12 lg:flex-row relative overflow-hidden">
           
            <div className="absolute inset-0 bg-primary" 
                 style={{ clipPath: 'polygon(0 0, 75% 0, 65% 100%, 0% 100%)' }}>
            </div>
            
         
            <div className="absolute inset-0" 
                 style={{ 
                   background: '#F8BBD9',
                   clipPath: 'polygon(65% 0, 100% 0, 100% 100%, 75% 100%)' 
                 }}>
            </div>


            <div className="relative z-20 lg:w-[50%] text-center lg:text-left sm:py-10 lg:py-0 sm:px-6">
                <h2 className="text-white text-6xl font-sans uppercase">
                    Every Score Has A Story
                </h2>


                <p className="text-white text-md mt-4 mb-2">
                    NEATT ("Not Eligible At This Time") provides comprehensive assistance for your barriers to borrowing. {/* client services for individuals */}
                </p>


                <div>
                    <Link to="/auth/client-registration">
                        <Button
                            text="Register"
                            theme={types.buttonTypes.BUTTON_THEME_TYPES.WHITE}
                            styles="w-[145px] h-[45px] p-0 text-md tracking-widest font-normal mt-4 mr-8"
                        />
                    </Link>
                </div>
            </div>


            <div className="absolute right-0 top-0 z-30 lg:w-[50%] h-full">
                <img
                    src={NeattHeaderpic}
                    height={500}
                    width={750}
                    className="w-full h-full object-cover"
                    alt="NEATT Consulting Header"
                />
            </div>
        </header>
    );
};


export default NeattHeader;






